var _circle, _circle2, _circle3, _circle4, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoiceSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 58.5,
    stroke: "white",
    strokeOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 99,
    cy: 99,
    r: 76.5,
    stroke: "#0D45DF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 99,
    cy: 99,
    r: 98.5,
    stroke: "#0D45DF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 99,
    r: 48,
    fill: "url(#paint0_linear_110_997)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 85.5C96.5147 85.5 94.5 87.5147 94.5 90V97.5C94.5 99.9853 96.5147 102 99 102C101.485 102 103.5 99.9853 103.5 97.5V90C103.5 87.5147 101.485 85.5 99 85.5ZM100.5 110.918V113.25C100.5 114.078 99.8284 114.75 99 114.75C98.1716 114.75 97.5 114.078 97.5 113.25V110.918C90.7501 110.171 85.5 104.449 85.5 97.5C85.5 96.6716 86.1716 96 87 96C87.8284 96 88.5 96.6716 88.5 97.5C88.5 103.299 93.201 108 99 108C104.799 108 109.5 103.299 109.5 97.5C109.5 96.6716 110.172 96 111 96C111.828 96 112.5 96.6716 112.5 97.5C112.5 104.449 107.25 110.171 100.5 110.918ZM99 82.5C103.142 82.5 106.5 85.8579 106.5 90V97.5C106.5 101.642 103.142 105 99 105C94.8579 105 91.5 101.642 91.5 97.5V90C91.5 85.8579 94.8579 82.5 99 82.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_110_997",
    x1: 33,
    y1: 81,
    x2: 147,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D45DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceSearch);
export default __webpack_public_path__ + "static/media/voice-search.9ee85d5bd34bbd1d828f084ceb8fec80.svg";
export { ForwardRef as ReactComponent };